import React, {FC, ReactNode} from 'react';

import {Trans} from '../../../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {TooltipCoordinator} from '../../../../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {
  CommentUnfurlErrorsEnum,
  CommentUnfurlModel,
  CommentUnfurlTypesEnum,
} from '../../../../../../../models/api/commentUnfurlModel';

export const CommentErrorInlineUnfurl: FC<{
  children: ReactNode;
  unfurl: CommentUnfurlModel;
}> = (props) => {
  const {unfurl} = props;
  return (
    <TooltipCoordinator
      isInline
      render={() => {
        if (unfurl.error === CommentUnfurlErrorsEnum.FORBIDDEN) {
          return <Trans id="comment-unfurl-tooltip-forbidden">You need to be invited to view this</Trans>;
        }

        return unfurl.type === CommentUnfurlTypesEnum.CONVERSATION ? (
          <Trans id="comment-unfurl-tooltip-conversation-not-found">
            This conversation could not be found
          </Trans>
        ) : (
          <Trans id="comment-unfurl-tooltip-message-not-found">This message could not be found</Trans>
        );
      }}
    >
      {props.children}
    </TooltipCoordinator>
  );
};
